module.exports = __webpack_public_path__ + "static/media/s9.8fbeae85.png";